moment = require 'moment/moment.js'
clndr = require './lib/clndr.js'

datePickerTemplate = require '../main.html.mustache'

class MPP.DatePicker

  constructor: ({el, input}) ->
    @$el = $ el
    @$input = $ input
    @initBindings()
    @render()

  render: ->
    @clndr = @$el.clndr
      weekOffset: parseInt(I18n.translations.js.dateTime.weekOffset)
      daysOfTheWeek: I18n.translations.js.dateTime.daysAbbreviations
      showAdjacentMonths: true
      render: (data) ->
        monthNumber = moment().month(data.month).format('M')
        data.month = I18n.translations.js.dateTime.months[monthNumber - 1]
        datePickerTemplate.render data
      clickEvents:
        click: (target) =>
          return unless target.events?.length
          # we manually trigger a "change" event because the input has a "readonly" attribute
          @$input.val(target.date.format('DD/MM/YYYY')).trigger 'change'
          @hideCalendar()

  showCalendar: ->
    @$el.slideDown()

  hideCalendar: ->
    @$el.trigger 'hiding'
    @$el.slideUp()

  setValidDates: (dates) ->
    return unless dates?.length > 0

    @clndr.options.constraints or= {}
    @clndr.options.constraints.startDate = dates[0]
    @clndr.options.constraints.endDate = dates[dates.length - 1]

    # parse the first month from a date string.
    # date string input: '2015-03-12'
    # firstMonth output: 3
    firstMonth = parseInt(dates[0].split('-')[1])
    firstMonthIndex = firstMonth - 1
    @clndr.setMonth firstMonthIndex

    events = []
    for date in dates
      events.push { date }
    @clndr.setEvents events


  isCalendarShown: ->
    return true if @$el.is(':visible')
    return false

  initBindings: ->

    @$input.on 'click', =>
      return if @$input.prop('disabled') is true
      return if @isCalendarShown()
      @showCalendar()

      onOutsideClick = (evt) =>
        # hide calendar if the target of the click isn't the calendar element nor a descendant of the calendar element
        @hideCalendar() if not @$el.is(evt.target) and @$el.has(evt.target).length is 0

      $(document).on 'mousedown', onOutsideClick
      @$el.on 'hiding', -> $(document).off 'mousedown', onOutsideClick
